import React, { useCallback } from 'react'
import { SnackbarAction, useSnackbar } from 'notistack'
import { nanoid } from 'nanoid'
import { Paper, Alert, AlertTitle } from '@mui/material'
import IconButton from '@mui/material/IconButton'

import CloseIcon from '@mui/icons-material/Close'

import { Toast } from '~shared/models/Toast'

import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() => ({
  toastContent: {
    maxWidth: '450px',
    wordWrap: 'break-word',
  },
}))

export function useAddToast() {
  const s = useStyles()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const addToast = useCallback((
    toast: Toast,
    toastKey: string = nanoid(8),
  ): string => {
    const snackbarMessage = (
      <Paper elevation={3}>
        <Alert
          severity={toast.severity}
          onClose={() => closeSnackbar(toastKey)}
        >
          <div className={s.toastContent}>
            {toast.title && <AlertTitle>{toast.title}</AlertTitle>}
            {toast.content}
          </div>
        </Alert>
      </Paper>
    )

    const snackbarAction: SnackbarAction = (key) =>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={() => closeSnackbar(key)}
      >
        <CloseIcon fontSize='small' />
      </IconButton>

    enqueueSnackbar(
      snackbarMessage,
      {
        key: toastKey,
        persist: toast.persist,
        action: snackbarAction,
      },
    )

    return toastKey
  }, [s.toastContent, enqueueSnackbar, closeSnackbar])

  return addToast
}
